import axios from "axios";

const EPAPER_API_BASE_URL = process.env.REACT_APP_EPAPER_API_BASE_URL || "";

const createUrl = (path) => `${EPAPER_API_BASE_URL}${path}`;

export const isRequestCanceled = (error) =>
  axios.isCancel?.(error) ||
  error?.code === "ERR_CANCELED" ||
  error?.name === "CanceledError" ||
  error?.name === "AbortError";

export const epaperService = {
  fetchDashboard: (params, { signal } = {}) =>
    axios.get(createUrl("/api/epaper/dashboard"), {
      params,
      timeout: 15000,
      signal,
    }),

  updateEdition: (payload) =>
    axios.post(createUrl("/api/epaper/jagran/edition/update/"), payload, {
      timeout: 60000,
      headers: { "Content-Type": "application/json" },
    }),
};

export default epaperService;
